import {
  Stack,
  Box,
  Typography
} from '@mui/material';
import _ from 'lodash';
import { CustomIcon } from 'modules/components/layer00';
import React from 'react';
import { theme } from 'theme';


// Create varaint like syntax to allow us to determine which metric should be displayed
// will become a gqlEnum on api
export type DashMetricTypes =
'newTasks' |
'overdueTasks' |
'dueTasks' |
'completedTasks' |
'unsubmittedDailyReports' |
'inspections' |
'accidents' |
'deliveries' |
'unsubmittedReports';

const __type2DashboardMetricIcon: Record<DashMetricTypes, React.ReactNode> = {
  newTasks: <CustomIcon.large.FC icon='STAR' stroke='white' />,
  overdueTasks: <CustomIcon.large.FC icon='ALERTTRIANGLE' stroke='white' />,
  dueTasks: <CustomIcon.large.FC icon='RIGHTARROW' stroke='white' />,
  completedTasks: <CustomIcon.large.FC icon='CHECKFLAT' stroke='white' />,
  unsubmittedDailyReports: <CustomIcon.large.FC icon='CALENDARALT' stroke='white' />,
  inspections: <CustomIcon.large.FC icon='SEARCH' stroke='white' />,
  accidents: <CustomIcon.large.FC icon='ALERT' stroke='white' />,
  unsubmittedReports: <CustomIcon.large.FC icon='CHECKFLAT' stroke='white' />,
  deliveries: <CustomIcon.large.FC icon='DELIVERY' stroke='white' />
};

const __type2DashboardMetricColor: Record<DashMetricTypes, string> = {
  newTasks: theme.palette.purple.main,
  overdueTasks: theme.palette.error.main,
  dueTasks: theme.palette.info.main,
  completedTasks: theme.palette.primary.main,
  unsubmittedDailyReports: theme.palette.info.main,
  inspections: theme.palette.purple.main,
  accidents: theme.palette.error.main,
  unsubmittedReports: theme.palette.primary.main,
  deliveries: theme.palette.primary.main
};


export type DashboardMetricProps = {
  metricType: DashMetricTypes;
  count?: number;
  title?: string;
};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DashboardMetricProps) => {

  return (
    <Stack
      flex='1 1 0'
      border={`1px solid ${theme.palette.secondary.dark}`}
      borderRadius='1.25rem'
      direction='row'
      columnGap='1rem'
      alignItems='center'
      paddingY='1.25rem'
      paddingX='1.5rem'
    >
      <Stack
        alignItems='center'
        borderRadius='.75rem'
        padding='.5rem'
        justifyContent='center'
        bgcolor={
          __type2DashboardMetricColor[props.metricType]
        }
      >
        {
          __type2DashboardMetricIcon[props.metricType]
        }
      </Stack>

      <Box
        display='block'
      >
        <Box>
          <Typography
            variant='activityHeader'
          >
            {props.count ?? '-'}
          </Typography>
        </Box>
        <Box>

          <Typography
            variant='activitySubHeaderPrimary'
          >
            {_.upperFirst(_.snakeCase(props.metricType).replace(/_/g, ' '))}
          </Typography>
        </Box>
      </Box>

    </Stack>
  );
};
